import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { ReactComponent as TransferIcon } from '../../../../../assets/icons/transfer_within_a_station.svg';
import EventAuthor from '../eventAuthor';
import EventDate from '../eventDate';
import useStyles from '../styles';

const StepChange = ({ translations, record }) => {
  const classes = useStyles();

  return (
    <div className={classes.authorEvent}>
      <div className={classes.eventHeader}>
        <div className={classes.eventInfo}>
          <div className={classes.icon}>
            <TransferIcon className={classes.eventIcon} />
          </div>
          <EventAuthor translations={translations} record={record} />
        </div>
        <EventDate record={record} />
      </div>
      <Typography
        className={classes.eventDetails}
        variant="body1"
        component="div"
      >
        {`${translations.movedFrom} `}
        <Typography variant="subtitle1" component="span">
          {record.from_step_title}
        </Typography>
        {` ${translations.to} `}
        <Typography variant="subtitle1" component="span">
          {record.step_title}
        </Typography>
      </Typography>
    </div>
  );
};

StepChange.propTypes = {
  translations: PropTypes.shape({}).isRequired,
  record: PropTypes.object.isRequired,
};

export default StepChange;
